/*
 * Programme de fidelite CARRON - storefront.
 * Consomme l'App Proxy same-origin /apps/loyalty/* (Shopify signe + injecte
 * l'identite client). Ne contient AUCUNE logique de points : il affiche l'etat
 * renvoye par CARRONPROD. Degradation gracieuse : toute erreur laisse la page
 * intacte (le hero visiteur rendu par Liquid reste visible).
 *
 * Contrat summary (cf. src/lib/loyalty/summary.ts) :
 *  non-membre : { member:false, segment, previewTiers:[{threshold,kind,labelFr,labelEn}] }
 *  membre     : { member:true, segment, memberSince, statusAcquired, statusAcquiredAt,
 *                 balance:{available, pending:[{points,arrivesAt}]},
 *                 tiers:[{threshold,kind,achieved,pointsToGo,labelFr,labelEn}],
 *                 tokens:[{id,rewardId,labelFr,labelEn,kind,expiresAt,code}] }
 */
(function () {
  var root = document.getElementById("loyalty-app");
  if (!root) return;

  var LOCALE = (root.getAttribute("data-locale") || "fr").indexOf("en") === 0 ? "en" : "fr";
  var LOGGED_IN = root.getAttribute("data-logged-in") === "true";
  var REGISTER_URL = root.getAttribute("data-register-url") || "/account/register";
  var LOGIN_URL = root.getAttribute("data-login-url") || "/account/login";
  var TCS_URL = root.getAttribute("data-tcs-url") || "";
  var PROXY = "/apps/loyalty";
  var TIMEOUT_MS = 4000;

  var T = {
    fr: {
      join: "Rejoindre le programme · en un clic",
      newsletter: "Sans obligation de s'abonner à la newsletter.",
      create: "Créer un compte",
      signin: "Se connecter",
      points: "points",
      arriving: "arrivant le",
      rewardToUse: "1 récompense à utiliser avant le",
      choosePiece: "Choisir ma pièce",
      chooseThis: "Choisir cette pièce",
      memberSince: "Membre depuis",
      status: "Statut",
      toNextReward: "points avant votre prochaine récompense",
      statusKept: "votre statut reste acquis",
      yourRewards: "Vos récompenses",
      pointsHistory: "Historique des points",
      generated: "Récompense obtenue · une pièce à choisir",
      tcs: "Conditions du programme",
    },
    en: {
      join: "Join the programme · one click",
      newsletter: "No obligation to subscribe to the newsletter.",
      create: "Create an account",
      signin: "Sign in",
      points: "points",
      arriving: "arriving on",
      rewardToUse: "1 reward to use before",
      choosePiece: "Choose my piece",
      chooseThis: "Choose this piece",
      memberSince: "Member since",
      status: "Status",
      toNextReward: "points to your next reward",
      statusKept: "your status remains acquired",
      yourRewards: "Your rewards",
      pointsHistory: "Points history",
      generated: "Reward earned · one piece to choose",
      tcs: "Programme terms",
    },
  }[LOCALE];

  function label(obj) {
    return (LOCALE === "en" ? obj.labelEn : obj.labelFr) || obj.labelFr || obj.labelEn || "";
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function fmtDate(iso) {
    if (!iso) return "";
    var d = new Date(iso + "T00:00:00");
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString(LOCALE === "en" ? "en-GB" : "fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  function proxyFetch(path, options) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () {
      ctrl.abort();
    }, TIMEOUT_MS);
    var opts = options || {};
    opts.signal = ctrl.signal;
    opts.headers = opts.headers || {};
    return fetch(PROXY + path, opts)
      .then(function (r) {
        clearTimeout(timer);
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .catch(function (err) {
        clearTimeout(timer);
        throw err;
      });
  }

  function setBusy(busy) {
    root.setAttribute("aria-busy", busy ? "true" : "false");
  }

  /* ---- Rendu ---- */

  function renderNonMember(summary) {
    var facts =
      '<div class="ly-facts">' +
      '<div class="ly-fact"><strong>1 pt</strong><span class="ly-kicker">= 1 €</span></div>' +
      summary.previewTiers
        .map(function (t) {
          return (
            '<div class="ly-fact"><strong>' +
            t.threshold +
            '</strong><span class="ly-kicker">' +
            esc(label(t)) +
            "</span></div>"
          );
        })
        .join("") +
      "</div>";

    if (!LOGGED_IN) {
      return (
        '<div class="ly-wrap ly-center ly-hero">' +
        '<div class="ly-kicker">CARRON · Loyalty</div>' +
        "<h1>A quiet thank-you, from the maison</h1>" +
        '<p class="ly-italic">Earn a point for every euro, quietly.</p>' +
        '<div class="ly-cta-row">' +
        '<a class="ly-btn" href="' +
        esc(REGISTER_URL) +
        '">' +
        esc(T.create) +
        "</a>" +
        '<a class="ly-btn ly-btn--ghost" href="' +
        esc(LOGIN_URL) +
        '">' +
        esc(T.signin) +
        "</a>" +
        "</div>" +
        tcsFooter() +
        facts +
        "</div>"
      );
    }
    return (
      '<div class="ly-wrap ly-center ly-hero">' +
      '<div class="ly-kicker">CARRON · Loyalty</div>' +
      "<h1>Welcome</h1>" +
      '<div class="ly-cta-row"><button class="ly-btn" data-ly-optin>' +
      esc(T.join) +
      "</button></div>" +
      tcsFooter() +
      '<p class="ly-italic" style="margin-top:12px">' +
      esc(T.newsletter) +
      "</p>" +
      facts +
      "</div>"
    );
  }

  function renderMember(summary) {
    var pendingTotal = summary.balance.pending.reduce(function (s, l) {
      return s + l.points;
    }, 0);
    var firstArrival = summary.balance.pending[0];
    var activeToken = summary.tokens[0];
    var rewardTier =
      summary.tiers.filter(function (t) {
        return t.kind === "reward";
      })[0] || null;

    var card =
      '<div class="ly-card">' +
      '<div class="ly-card-head">CARRON · Loyalty</div>' +
      '<div class="ly-balance">' +
      summary.balance.available +
      ' <span style="font-size:22px">' +
      esc(T.points) +
      "</span></div>" +
      (firstArrival
        ? '<div class="ly-pending">+ ' +
          pendingTotal +
          " " +
          esc(T.points) +
          " " +
          esc(T.arriving) +
          " " +
          esc(fmtDate(firstArrival.arrivesAt)) +
          "</div>"
        : "") +
      (activeToken
        ? '<div class="ly-reward-badge">' +
          esc(T.rewardToUse) +
          " " +
          esc(fmtDate(activeToken.expiresAt)) +
          "</div>"
        : "") +
      '<hr class="ly-card-rule" />' +
      '<div class="ly-card-meta"><span>' +
      esc(T.memberSince) +
      "<br>" +
      esc(fmtDate(summary.memberSince)) +
      "</span>" +
      (summary.statusAcquired
        ? "<span>" + esc(T.status) + "<br>" + esc(fmtDate(summary.statusAcquiredAt)) + "</span>"
        : "") +
      "</div></div>";

    var gauge = "";
    if (rewardTier) {
      var pct =
        Math.round(
          Math.max(0, Math.min(100, (summary.balance.available / rewardTier.threshold) * 100)) * 10,
        ) / 10;
      gauge =
        '<div><div class="ly-kicker">Progression</div>' +
        '<div class="ly-gauge-track"><div class="ly-gauge-fill" style="width:' +
        pct +
        '%"></div>' +
        '<div class="ly-gauge-dot ' +
        (summary.statusAcquired ? "ly-gauge-dot--reached" : "") +
        '" style="left:66%"></div>' +
        '<div class="ly-gauge-dot" style="left:100%"></div></div>' +
        '<div class="ly-gauge-legend">' +
        rewardTier.pointsToGo +
        " " +
        esc(T.toNextReward) +
        (summary.statusAcquired ? " · " + esc(T.statusKept) : "") +
        "</div></div>";
    }

    var rewards =
      '<div style="margin-top:56px"><div class="ly-kicker">' +
      esc(T.yourRewards) +
      "</div>" +
      (activeToken
        ? '<div class="ly-active-reward"><span class="ly-italic">' +
          esc(label(activeToken)) +
          " · " +
          esc(T.rewardToUse) +
          " " +
          esc(fmtDate(activeToken.expiresAt)) +
          '</span><button class="ly-btn" data-ly-redeem="' +
          esc(activeToken.id) +
          '">' +
          esc(T.choosePiece) +
          "</button></div>"
        : "") +
      "</div>";

    return (
      '<div class="ly-wrap">' +
      card +
      '<div class="ly-grid2">' +
      gauge +
      "</div>" +
      rewards +
      "</div>"
    );
  }

  function tcsFooter() {
    if (!TCS_URL) return "";
    return '<p class="ly-tcs"><a href="' + esc(TCS_URL) + '">' + esc(T.tcs) + "</a></p>";
  }

  function render(summary) {
    // Membre : lien conditions en pied ; non-membre : sous le CTA (cf. renderNonMember).
    root.innerHTML = summary.member
      ? renderMember(summary) + tcsFooter()
      : renderNonMember(summary);
    bind();
  }

  /* ---- Actions ---- */

  function bind() {
    var optin = root.querySelector("[data-ly-optin]");
    if (optin) {
      optin.addEventListener("click", function () {
        setBusy(true);
        proxyFetch("/opt-in", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ source: "loyalty_page" }),
        })
          .then(function (summary) {
            setBusy(false);
            if (summary && summary.member) render(summary);
          })
          .catch(function () {
            setBusy(false);
          });
      });
    }
    root.querySelectorAll("[data-ly-redeem]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-ly-redeem");
        setBusy(true);
        proxyFetch("/redeem", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ redemptionId: id }),
        })
          .then(function (res) {
            setBusy(false);
            if (res && res.ok && res.code) {
              // A5 : confirmation du choix + code (herite de la date du token).
              root.querySelector(".ly-active-reward").outerHTML =
                '<div class="ly-active-reward"><span class="ly-italic">' +
                esc(res.code) +
                "</span></div>";
            }
            reload();
          })
          .catch(function () {
            setBusy(false);
          });
      });
    });
  }

  function reload() {
    proxyFetch("/summary?locale=" + LOCALE)
      .then(render)
      .catch(function () {
        /* garde le rendu courant */
      });
  }

  /* ---- Init : degradation gracieuse ---- */
  proxyFetch("/summary?locale=" + LOCALE)
    .then(function (summary) {
      root.hidden = false;
      render(summary);
    })
    .catch(function () {
      // Proxy indisponible : on laisse le fallback Liquid (hero visiteur) visible,
      // on ne touche a rien. La page reste intacte.
    });
})();
